import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 1,
  class: "gfu-product-set-item-wrapper__thumb-spacer",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "gfu-product-set-item-details" }
const _hoisted_4 = {
  key: 0,
  "data-qa": "quantity"
}
const _hoisted_5 = {
  class: "gfu-hd",
  "data-qa": "product-name"
}
const _hoisted_6 = {
  key: 1,
  class: "_pa-0 _flex _grow-1 _flex-basis-60"
}
const _hoisted_7 = { class: "_grow-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_thumb = _resolveComponent("base-thumb")
  const _component_product_set_item_split_field = _resolveComponent("product-set-item-split-field")
  const _component_product_option_field = _resolveComponent("product-option-field")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-product-set-item-wrapper",
    "data-qa": `product-set-item-details:${$props.productSetItemID}_${$props.index}`
  }, [
    ($options.hasImage && !$options.isSecondary)
      ? (_openBlock(), _createBlock(_component_base_thumb, {
          key: 0,
          size: "small",
          "image-url": $options.imageUrl,
          alt: $options.name
        }, null, 8 /* PROPS */, ["image-url", "alt"]))
      : ($options.hasImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(['gfu-product-set-item-wrapper__content', {'gfu-product-set-item-wrapper__content--middle': !$options.hasOptions}])
    }, [
      _createElementVNode("div", _hoisted_3, [
        (!$options.showAmountControls)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($props.quantity) + "x ", 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("span", null, [
          _createElementVNode("strong", _hoisted_5, _toDisplayString($options.name), 1 /* TEXT */)
        ])
      ]),
      ($options.showAmountControls)
        ? (_openBlock(), _createBlock(_component_product_set_item_split_field, {
            key: 0,
            quantity: $props.quantity,
            "is-secondary": $options.isSecondary,
            "can-product-be-split": $props.canProductBeSplit,
            "available-to-split": $props.availableToSplit,
            "should-focus": $props.shouldFocus,
            onSplit: $options.onSplit,
            onRemove: $options.onRemove,
            onAmountInput: $options.onAmountInput
          }, null, 8 /* PROPS */, ["quantity", "is-secondary", "can-product-be-split", "available-to-split", "should-focus", "onSplit", "onRemove", "onAmountInput"]))
        : _createCommentVNode("v-if", true),
      ($options.hasOptions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.options, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'product-set-item-option-' + option.productOptionID
                }, [
                  _createVNode(_component_product_option_field, {
                    option: option,
                    "selected-option-value-id": option.productOptionValueID,
                    "currency-symbol": $props.currencySymbol,
                    "relative-factor-with-commission": $props.relativeFactorWithCommission,
                    disabled: !$props.canChangeOptions,
                    onChange: $options.setSelectedProductOption
                  }, null, 8 /* PROPS */, ["option", "selected-option-value-id", "currency-symbol", "relative-factor-with-commission", "disabled", "onChange"])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ], 8 /* PROPS */, _hoisted_1))
}